export enum FrequencyCadenceTypeEnum {
  SpecificDateAndTime = 1,
  Daily = 2,
  Weekly = 3,
  Monthly = 4,
  Prn = 5,
  Evaluation = 6
}

export const FrequencyCadenceTypeOptions = [
{ id: 1, label: 'Specific Date & Time', needsAbbreviation: false },
{ id: 2, label: 'Daily', needsAbbreviation: true },
{ id: 3, label: 'Weekly', needsAbbreviation: true },
{ id: 4, label: 'Monthly', needsAbbreviation: true },
{ id: 5, label: 'PRN', needsAbbreviation: false },
{ id: 6, label: 'Evaluation', needsAbbreviation: false }
];
